import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { CustomValidators } from 'src/app/providers/CustomValidator';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LicenceAgrementComponent } from '../licence-agrement/licence-agrement.component';
import { ApiService } from 'src/app/_services/api.service';
import { DialogService } from 'primeng/dynamicdialog';
import { CompanyCredentialsComponent } from '../company-credentials/company-credentials.component';
import { HttpErrorResponse } from '@angular/common/http';
import { SocialRegisterRequestModel } from 'src/app/_models/Authentication/social-register-request';
import { FacebookProfileModel } from 'src/app/_models/User/FacebookProfileModel';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  registrationForm: UntypedFormGroup = new UntypedFormGroup({});
  submitted = false;
  loadingPage = false;
  list: any[];
  registerUserResult: any;
  contires: Array<any>;

  constructor(
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog,
    private apiService: ApiService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public messageService: MessageService,
  ) {
    this.list = [
      { name: 'Cafes and boutiques', checked: false, id: 1 },
      { name: 'Pubs and bars', checked: false, id: 2 },
      { name: 'Restaurants and bistros', checked: false, id: 3 },
      { name: 'Clubs and discotheques ', checked: false, id: 4 },
      // { name:'Halls and galeries', checked: false, id: 5 },
      { name: 'Private and premium clubs', checked: false, id: 6 },
      // { name:'Arenas and malls', checked: false, id: 7 },
      // { name:'Public spaces', checked: false, id: 8 }
    ]
  }

  ngOnInit(): void {
    this.initLoginForm();
    this.apiService.getallcountrynames().subscribe( result => {
      this.contires = result;
    });
  }

  private initLoginForm(): void {
    this.registrationForm = new UntypedFormGroup(
      {
        firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z ]*$')]),
        lastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]*$')]),
        password: new UntypedFormControl('', [Validators.required, Validators.minLength(6),
        Validators.pattern('^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-Za-z\\d!$%@#+£€*?_|&.,\^\=\"\'\;\:-]{6,}$')]),
        confirmPassword: new UntypedFormControl('', [Validators.required]),
        email: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
        termsOfConditionsAccepted: new UntypedFormControl(false, Validators.requiredTrue)
      },

      //@ts-ignore
      CustomValidators.mustMatch('password', 'confirmPassword') // insert here
    );
  }

  onRegistrationFormSubmit(): void {
    this.submitted = true;

    if (this.registrationForm.invalid) {
      return;
    }
    this.loadingPage = true;
    let data = this.registrationForm.value;
    data.language = this.getLanguageId();
    data.termsOfConditionsVersion = "1";
    delete data.confirmPassword;
    this.authService.register(data).subscribe((response) => {
      this.loadingPage = false;
      this.registerUserResult = response;
      this.authService._isSuperAdmin$.next(false);
      this.authService._isTechSupport$.next(false);
      this.authService._isAdvertiser$.next(true);
      this.router.navigate(['/promoter/venues']);
    },(error) =>{
      this.loadingPage = false;
    });

  }

  registerWithFacebook() {
    this.authService.facebookAuth().then((result) => {
      this.loadingPage = true;
      const socialRegisterCredentials = new SocialRegisterRequestModel();
      // console.log(result)
      // result.user?.getIdToken().then((jwtToken:string) => {
      //   socialRegisterCredentials.token = jwtToken;
      // });
      //@ts-ignore
      socialRegisterCredentials.token = result.user._delegate.accessToken;
      let obj = result.additionalUserInfo?.profile?.valueOf() as FacebookProfileModel;
      socialRegisterCredentials.firstName = obj.first_name;
      socialRegisterCredentials.lastName = obj.last_name;
      socialRegisterCredentials.email = obj.email;
      // @ts-ignore
      socialRegisterCredentials.pictureUrl = obj.picture.data.url;
      socialRegisterCredentials.phone = result.user?.phoneNumber;
      socialRegisterCredentials.languageId = this.getLanguageId();
      // this.companyCredentialsDialog(socialRegisterCredentials);
      this.authService.registerWithFacebook(socialRegisterCredentials).subscribe((response)=>{
          this.loadingPage = false;
          this.authService._isSuperAdmin$.next(false);
          this.authService._isTechSupport$.next(false);
          this.authService._isAdvertiser$.next(true);
          this.router.navigate(['/promoter/venues']);
        },(error)=>{
          this.loadingPage = false;
        })
    },(error:HttpErrorResponse)=>{
      this.loadingPage = false;
      if(!error.message.includes('popup has been closed by the user')){
        this.messageService.add({ severity: 'warn', summary: error.message, life: 4000 });
      }
    });
  }

  companyCredentialsDialog(socialRegisterCredentials: SocialRegisterRequestModel) {
    const ref = this.dialogService.open(CompanyCredentialsComponent, {
      data: {
        socialRegisterCredentials: socialRegisterCredentials
      },
      autoZIndex: false,
      header: this.translate.instant('INFO.COMPANY_CREDENTIALS'),
      width: '720px'
    });
    this.loadingPage=true;
    ref.onClose.subscribe((success:boolean) => {
      this.loadingPage=false;
      if(success){
        this.authService._isSuperAdmin$.next(false);
        this.authService._isTechSupport$.next(false);
        this.authService._isAdvertiser$.next(true);
        this.router.navigate(['/promoter/venues']);
      }
    });
  }

  openTermsAndConditions() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal-large';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.scrollStrategy;
    dialogConfig.minWidth = "960px";
    dialogConfig.maxWidth = "960px";
    dialogConfig.maxHeight = "500px";
    const dialogRef = this.dialog.open(TermsAndConditionsComponent, dialogConfig);
  }

  openLicenceAgrement() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal-large';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.scrollStrategy;
    dialogConfig.minWidth = "960px";
    dialogConfig.maxWidth = "960px";
    dialogConfig.maxHeight = "500px";
    const dialogRef = this.dialog.open(LicenceAgrementComponent, dialogConfig);
  }

  getLanguageId(){
    if(window.localStorage.getItem('languageId') != null && window.localStorage.getItem('languageId')){
      return window.localStorage.getItem('languageId');
    }else {
      return "1";
    }
  }

  get registrationFormControls() {
    return this.registrationForm.controls;
  }

  get company() { return this.registrationForm.get('company'); }

  get companyName() { return this.company?.get('companyName') }
  get hqlocation() { return this.company?.get('hqlocation') }
  get countryId() { return this.company?.get('countryId') }
  get taxNumber() { return this.company?.get('taxNumber') }
  get companyPhone() { return this.company?.get('phone') }
  get companyEmail() { return this.company?.get('email') }

}
